import axios from '@/axios';

const RESOURCE_NAME = '/public';

export default {
    checkEcosystemInviteHash(hash) {
        return axios.get(`${RESOURCE_NAME}/check-ecosystem-invite-hash?hash=${hash}`)
    },
}
